export default __webpack_public_path__ + "static/by-company-type-bid-caching-glass-d794897f07a545461070278a133fc8cf.svg";